import { Box, Button } from "@amzn/awsui-components-react";
import { EmptyStateDefinition } from "../../config/recentTransactionTableConfig";

interface EmptyStateProps {
  error: Error | null;
  filteringText: string;
  config: EmptyStateDefinition;
  action?: { text: string; onClick: () => void };
}

export function EmptyState({
  error,
  filteringText,
  config,
  action,
}: EmptyStateProps) {
  const status = (error as any)?.response?.status;
  const state = error
    ? status === 403
      ? config.permission
      : config.error
    : filteringText
    ? config.filtered
    : config.default;

  return (
    <Box textAlign="center" color="inherit">
      <b>{state.heading}</b>
      <Box padding={{ bottom: "s" }} variant="p" color="inherit">
        {state.message}
      </Box>
      {action && (
        <Button variant="primary" onClick={action.onClick}>
          {action.text}
        </Button>
      )}
      {state.link && (
        <Button variant="primary" href={state.link}>
          Request Access
        </Button>
      )}
    </Box>
  );
}
